// extracted by mini-css-extract-plugin
module.exports = {"mainContent":"styles_mainContent__1dx_9"};